import React from "react";
import PatientScriptInfo from "../../../global/view/patient-script-infoForm";

export default function OTCPatientScriptInfoFull() {
  return <PatientScriptInfo hideFields={['practitioner']} />;
}